import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getGallectionStreamId } from '../helpers';
import { getCurrentMediaSource } from '../selectors';
export default function*() {
    const mediaSource = yield select(getCurrentMediaSource);
    const streamId = getGallectionStreamId(mediaSource);
    const isFetching = yield select(selectors.isFetching, streamId);
    if (isFetching) {
        return;
    }
    yield put(withOffset.actions.fetch(streamId));
}

//# sourceMappingURL=fetchMoreGallections.js.map